module.exports = __webpack_public_path__ + "media/pages/assets/images/alternative-shelter-828e3a1be74592d66172f54bb2b6d1fe.svg";